<script>
import { Line, mixins } from 'vue-chartjs';

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['change'],
  watch: {
    change() {
      this.$data._chart.update();
    },
    height(val) {
      this.$data._chart.update();
    },
  },
  data() {
    return {
      options: {
        scales: {
          xAxes: [
            {
              display: false,
              gridLines: {
                display: false,
              },
              ticks: {
                stacked: true,
              },
            },
          ],
          yAxes: [
            {
              display: false,
              gridLines: {
                display: false,
              },
              ticks: {
                stepSize: 10,
                suggestedMin: 0,
                suggestedMax: 100,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: false,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
